module.exports = __webpack_public_path__ + "static/media/Icon feather-upload-cloud.cad0a5d1.svg";